import moment from "moment";

export const datetimecapital = (value) => {
	if (!value) return ''
	return moment(String(value)).format('MMM DD, YYYY h:mm A');
};
